import { a as __assign, _ as __spreadArray } from '../../../../tslib.es6-a39f91fc.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { useState } from 'react';
import { T as TableSection } from '../../../../TableSection-ebace923.js';
import ChevronDownIcon from '../../../icon/icons/ChevronDown.js';
import ChevronUpIcon from '../../../icon/icons/ChevronUp.js';
import { Card } from '../../../cards/card/index.js';
import { s as styleInject } from '../../../../style-inject.es-1f59c1d0.js';
import { c as classNames } from '../../../../index-6ea95111.js';
import { Collapsible } from './Collapsible.js';
import { IconRenderer } from '../IconRenderer/IconRenderer.js';
import '../TableCell/TableCell.js';
import '../TableCell/BaseCell/BaseCell.js';
import '../../../icon/icons/CheckThick.js';
import '../../../icon/IconWrapper/IconWrapper.js';
import '../../../icon/icons/StarFilled.js';
import '../../../icon/icons/X.js';
import '../../../icon/icons/ZapFilled.js';
import '../TableCell/BaseCell/MiniProgressBar/MiniProgressBar.js';
import '../../../../index-af1860d8.js';
import '../../../../_commonjsHelpers-4730bd53.js';
import '../../../comparisonTable/components/TableInfoButton/index.js';
import '../../../icon/icons/Info.js';
import '../../../../index-5e72c3d4.js';
import '../TableCell/CTACell/CTACell.js';
import '../TableCell/CardCell/CardCell.js';
import '../../../icon/icons/ChevronRight.js';
import '../TableCell/ButtonCell/ButtonCell.js';
import '../../../button/index.js';

var css_248z = ".TableContents-module_cardWrapper__2OVMv {\n  height: 88px;\n}\n\n.TableContents-module_card__Mmz6h {\n  position: absolute;\n  left: 0;\n  right: 0;\n  z-index: 3;\n}\n\n.TableContents-module_cardIcon__2DXbp {\n  width: 20px;\n  margin-right: 8px;\n}";
var styles = {"cardWrapper":"TableContents-module_cardWrapper__2OVMv","card":"TableContents-module_card__Mmz6h","cardIcon":"TableContents-module_cardIcon__2DXbp"};
styleInject(css_248z);

var TableContents = function (_a) {
    var _b, _c;
    var className = _a.className, collapsibleSections = _a.collapsibleSections, tableData = _a.tableData, _d = _a.hideColumns, hideColumns = _d === void 0 ? [] : _d, hideDetails = _a.hideDetails, isMobile = _a.isMobile, openModal = _a.openModal, shouldHideDetails = _a.shouldHideDetails, title = _a.title, cellReplacements = _a.cellReplacements, imageComponent = _a.imageComponent;
    var _e = useState(null), isSectionOpen = _e[0], setOpenSection = _e[1];
    var firstHeadRow = (_c = (_b = tableData === null || tableData === void 0 ? void 0 : tableData[0]) === null || _b === void 0 ? void 0 : _b.rows) === null || _c === void 0 ? void 0 : _c[0];
    var tableWidth = isMobile ? "".concat((firstHeadRow === null || firstHeadRow === void 0 ? void 0 : firstHeadRow.length) * 50, "%") : '';
    var handleToggleSection = function (index) {
        setOpenSection(function (currentSection) {
            return currentSection === index ? null : index;
        });
    };
    return (jsx("div", { style: { width: tableWidth }, children: tableData.map(function (_a, index) {
            var rows = _a.rows, _b = _a.section, section = _b === void 0 ? {} : _b;
            var isFirstSection = index === 0;
            var isExpanded = !collapsibleSections
                ? true
                : isSectionOpen === index || isFirstSection;
            var isVisible = hideDetails ? !shouldHideDetails : true;
            var renderedIcon = (jsx(IconRenderer, { icon: section.icon, imageComponent: imageComponent, width: 20 }));
            return ((isFirstSection || isVisible) && (jsxs("div", { children: [(section === null || section === void 0 ? void 0 : section.title) && (jsx("div", { className: styles.cardWrapper, children: jsx("div", { className: classNames(styles.card, 'p0'), children: jsx(Card, __assign({ actionIcon: isExpanded ? (jsx(ChevronUpIcon, { size: 24 })) : (jsx(ChevronDownIcon, { size: 24 })), "aria-expanded": isExpanded ? 'true' : 'false', "aria-hidden": true, classNames: {
                                    wrapper: 'bg-purple-50 pl16',
                                    icon: classNames(styles.cardIcon, 'tc-grey-900'),
                                }, dropShadow: false, icon: renderedIcon, title: section.title, titleVariant: "medium" }, (collapsibleSections
                                ? {
                                    onClick: function () { return handleToggleSection(index); },
                                }
                                : {}))) }) })), jsx(Collapsible, { isExpanded: isExpanded, children: jsx(TableSection, { className: classNames(className, 'mb24'), tableCellRows: isFirstSection ? rows : __spreadArray([firstHeadRow], rows, true), hideColumns: hideColumns, hideHeader: true, openModal: openModal, title: "".concat(title).concat((section === null || section === void 0 ? void 0 : section.title) ? " - ".concat(section.title) : ''), width: tableWidth, cellReplacements: cellReplacements, imageComponent: imageComponent }) })] }, index)));
        }) }));
};

export { TableContents };
//# sourceMappingURL=TableContents.js.map
